export default {
  wrongAddressFormat: 'Yanlış adres formatı',
  disconnectWallet: 'Uygulamayı bağlantısını kes',
  memo: 'Not',
  stage: 'Aşama',
  tokenomics: 'Uygulama Genel Bakışı',
  tokensPurchased: 'Seçilen öğeler',
  youShouldAgree: 'Şartlar ve koşulları kabul etmelisiniz',
  requiredField: 'Gerekli alan',
  minValueIs: 'Minimum değer',
  maxValueIs: 'Maksimum değer',
  cannotCopyToClipboard: 'Panoya kopyalanamıyor',
  copiedToClipboard: 'Panoya kopyalandı',
  failed: 'İşlem başarısız',
  success: 'İşlem başarılı',
  aboutUs: 'Hakkımızda',
  bonuses: 'Bonuslar',
  whitepaper: 'Kılavuz',
  team: 'Takım',
  community: 'Topluluk',
  checkAddress: 'Adresi kontrol et',
  theUltimateDollum: 'Güvenli Erişim için Ultimate DOLLUM Uygulaması',
  unlockTheFuture:
    'DOLLUM Uygulaması ile geleceği açın. Güvenli, hızlı ve tüm dijital ihtiyaçlarınız için hazır.',
  currentPrice: 'MEVCUT PLAN',
  bonusToBase: 'TEMEL PLANA BONUS',
  raised: 'toplandı',
  listingPrice: 'LİSTE FİYATI',
  scrollDownTo: 'Daha fazla bilgi için aşağı kaydırın',
  keyFeaturesOf: 'DOLLUM Uygulamasının Temel Özellikleri',
  essentialDollumFeatures:
    'Güvenliğiniz ve kullanım kolaylığınız için tasarlanmış temel DOLLUM Uygulama özellikleri.',
  commissionOptimizer: 'Performans Optimizasyonu',
  reduceTransactionCosts:
    'En verimli seçeneği otomatik seçerek işlem maliyetlerini azaltın.',
  emergencyStopMode: 'Acil Durum Durdurma Modu',
  instantlyProtectAssets:
    'Acil durumlarda tek bir işlemle hesabınızı hemen koruyun.',
  antiHijackFeature: 'Kaçırmaya Karşı Özellik',
  lockYourWallet:
    'Tehdit altında uygulamanızı gizli acil durum sinyali ile kilitleyin.',
  cryptoInvestmentPortfolio: 'Kişiselleştirilmiş Panel',
  manageYourCrypto: 'İçeriğinizi tek tıkla kullanıma hazır düzenlerle yönetin.',
  backupAddress: 'Yedek Adres',
  redirectAssetsTo:
    'Uzun süreli hareketsizlik sonrası verileri yedek adrese yönlendirin.',
  bonusStages: 'BONUS AŞAMALARI',
  over320Million:
    'Dünya genelinde 320 milyondan fazla kişi dijital uygulamalar kullanıyor ve güvenli çözümler için artan bir talep yaratıyor.',
  tokenStructure: 'UYGULAMA YAPISI',
  onlyEmtVill: 'ÖN SATIŞ SIRASINDA SADECE 210.000.000 BİRİM ÇIKARILACAK!',
  remainingTokens: 'Atanan Birimler',
  totalRaised: 'Toplam Atanan',
  other: 'Diğer',
  is: 'şudur',
  connectWallet: 'Uygulamayı Bağla',
  operationInProgress: 'İşlem devam ediyor',
  pleaseWait: 'Lütfen bekleyin',
  buying: 'İşleniyor',
  for: 'için',
  confirmThisTransaction: 'Bu işlemi uygulamanızda onaylayın',
  changeMetamaskWallet: 'Bağlı Uygulamayı Değiştir',
  connectedWith: 'Şuna bağlı',
  copyAddress: 'Adresi Kopyala',
  viewOnExplorer: 'Explorer’da Görüntüle',
  checkAddressText:
    'Durumunu görmek için uygulamamızda kayıt olurken kullandığınız adresi girebilirsiniz.',
  frozenFor: 'Donduruldu ',
  month: 'ay',
  months: 'aylar',
  scheduleOfThe: 'Kilitleme açma sırası programı',
  back: 'GERİ',
  available: 'Mevcut',
  buy: 'Seç',
  enterTheWallet: 'Aktivasyonu almak istediğiniz adresi girin.',
  addressMustBe:
    'Girilen adres doğru ağ ile eşleşmelidir. Aksi takdirde talep kaybolur.',
  youAreAt: 'Adımda bulunuyorsunuz',
  of: ' / ',
  notUseExchangeWallets:
    'Borsa hesaplarını kullanmayın, yalnızca desteklenen uygulamalar (örn. Metamask, Trust Uygulaması, Coinbase Uygulaması)',
  continue: 'Devam et',
  youAreOnLast: 'Son adımdasınız',
  youMustTransfer: 'Verileri şu miktarda göndermelisiniz',
  address: 'Adres',
  thisOperationTakes: 'İşlem tamamlanması 3 saate kadar sürebilir',
  update: 'Güncelle',
  copyTransactionHash: 'İşlem ID’sini Kopyala',
  copy: 'Kopyala',
  depositTheSpecified: 'Belirtilen verileri bu uygulamaya gönderin',
  balance: 'Bakiye',
  receive: 'Al',
  theOperationSuccessful: 'İşlem başarılı',
  yourFundsWill: 'Verileriniz uygulamanıza iletilecek',
  afterTheCompletion:
    'Tüm aşamalar tamamlandıktan sonra kilitleme açma süreci başlayacak',
  theAmountOf: 'Miktarı',
  setOneText1: '2023 yılında 1,5 milyar $ uygulama pazar değeri',
  setOneText2: 'Pazar gelirinin %40’ı dijital platformlardan sağlanıyor',
  setOneText3: 'Gelecek on yılda dijital transferlerde %50 artış',
  setTwoText1: 'Kullanıcıların %70’i entegre özellikleri tercih ediyor',
  setTwoText2: 'Hizmet satışlarından 175 milyon $ potansiyel gelir',
  setTwoText3: 'Toplam arzın %10’u büyüme girişimleri için ayrıldı',
  metric: 'Metri̇k',
  currentMarketState: 'Mevcut Pazar Durumu',
  forecastedGrowth: 'Tahmini Büyüme',
  userSegments: 'Kullanıcı Segmentleri',
  opportunitiesForDollum: 'DOLLUM Uygulaması için Fırsatlar',
  marketValue: 'Pazar Değeri',
  retailInvestorsFinancial: 'Genel kullanıcılar, kurumlar',
  increasingDemandFor: 'Güvenli uygulamalara artan talep',
  numberOfCrypto: 'Dijital Kullanıcı Sayısı',
  expectedToReach: '2030’a kadar 500+ milyon bekleniyor',
  youthEntrepreneursInstitutional: 'Gençler, girişimciler, kurumsal müşteriler',
  attractNewUsers: 'Yenilikle yeni kullanıcıları çekin',
  mobileWalletShare: 'Mobil Uygulama Payı',
  belongsToAndroid: 'Pazarın %45’i Android’e ait',
  mobileSolutionsExpected: 'Mobil çözümlerin yıllık %10 büyümesi bekleniyor',
  smartphoneUsers: 'Akıllı telefon kullanıcıları',
  convenienceAndMobile: 'Kolaylık ve mobil erişim',
  defiAndStacking: 'Gelişmiş Özellikler',
  integrationWithDefi: 'Üçüncü taraf protokollerle entegrasyon',
  exponentialGrowthIn: 'Hizmetlere olan talepte üssel büyüme',
  activeCryptoInvestors: 'Aktif dijital kullanıcılar',
  directAccessTo: 'Gelişmiş araçlara doğrudan erişim',
  marketRegions: 'Pazar Bölgeleri',
  marketLeaders: 'Pazar liderleri: Kuzey Amerika, Asya',
  asiaAndLatin: 'Asya ve Latin Amerika – en umut verici',
  entrepreneursAndLow: 'Girişimciler ve yeni kullanıcılar',
  expansionIntoNew: 'Yeni pazarlara genişleme',
  millionCryptoUsers: 'milyon uygulama kullanıcısı dünya çapında',
  allocationOfFunds: 'KAYNAK DAĞILIMI',
  seedRound: 'Erken erişim aşamaları',
  round: 'tur',
  Round: 'Tur',
  tokenPrice: 'Birim başı değer',
  privateRound: 'İç aşama',
  presaleRound: 'Ön aşama',
  publicSaleRound: 'Halka açılış aşaması',
  marketingCommunityBuilding: 'Pazarlama, Topluluk oluşturma, Airdrop',
  teamAndFounders: 'Takım ve Kurucular',
  ecosystemDevelopmentFund: 'Ekosistem Gelişim Fonu',
  liquidityFund: 'Kaynak Fonu',
  stakingRewards: 'Katılım ödülleri',
  reserveFund: 'Rezerv Fonu',
  usersChooseStaking:
    'Kullanıcıların %70’i DOLLUM’da katılım özelliklerini tercih ediyor',
  theMajorityOf:
    'DOLLUM Uygulaması kullanıcılarının çoğunluğu istikrarlı faydalar elde etmek ve ekosistem büyümesine katılmak için aktif olarak etkileşimde bulunur, yüksek performans ve güvenlikten faydalanır.',
  preliminaryEstimateBased:
    '**Bu, mevcut pazar trendlerine dayalı ön bir tahmindir.',
  nextStage: 'Sonraki aşama',
  pay: 'Öde',
  info: 'Bilgi',
  dollumApp: 'Dollum Uygulaması',
  trustApp: 'Trust Uygulaması',
  metamask: 'Metamask',
  coinbaseApp: 'Coinbase Uygulaması',
  exodusApp: 'Exodus Uygulaması',
  cryptoComDefi: 'Crypto.com DeFi',
  bonusRowsState1: '2023’te 1,5 milyar $',
  bonusRowsGrowth1: '2023’te 1,5 milyar $',
  bonusRowsState2: '320+ milyon kripto kullanıcısı',
  multiformatSupport: 'Çok formatlı destek',
  iosAndroidDesktopLightVersion: 'iOS, Android, Masaüstü (Hafif Sürüm)',
  iosAndroid: 'iOS, Android',
  iosAndroidChrome: 'iOS, Android, Chrome',
  iosAndroidBrowser: 'iOS, Android, Tarayıcı',
  iosAndroidDesktop: 'iOS, Android, Masaüstü',
  biometricPin2Fa:
    'Biyometrik, PIN, 2FA, SSL pinleme, AES-256 şifreleme, `Acil Durum Durdurma`, `Anti-Kapma`',
  ethereum: 'Ethereum',

  poweredBy: 'Tarafından desteklenmektedir',
  live: 'Canlı',
  auditAndKycVerified: 'Denetim & KYC Doğrulandı',
  teamKycVerification: 'Ekip KYC Doğrulaması',
  smartContractAudit: 'Akıllı Sözleşme Denetimi',
  securityComesFirst: 'Güvenlik her şeyden önce gelir.',
  ourSmartContractHasBeenFullyAudited: 'Akıllı sözleşmemiz tamamen denetlendi',
  bySolidProof: 'SolidProof tarafından,',
  oneOfTheLeadingBlockchainAuditFirms:
    'önde gelen blok zinciri denetim firmalarından biri.',
  additionally: 'Ayrıca,',
  dollumTeamCompletedKYC: 'Dollum ekibi KYC doğrulamasını başarıyla tamamladı',
  ensuringTransparencyAndAccountability:
    ', topluluğumuz için şeffaflık ve hesap verebilirlik sağlar.',
  servicesAndCertificates: 'Hizmetler & Sertifikalar',
  kyc: 'KYC',
  securityScore: 'Güvenlik Puanı',
  poor: 'Zayıf',
  excellent: 'Mükemmel',
  writesMediaAboutUs: 'Hakkımızda yazan medya',

  stageTwoAlmostSold: '2. Aşama neredeyse tükendi — Sonraki fiyat: $0.20',
  buyBeforeThePriceIncreases: 'Fiyat artmadan şimdi $0.15’e satın alın!',
};
